exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".drawerContainer {\n  border: solid 0.3px rgba(0, 0, 0, 0);\n  left: 0px;\n  bottom: 0px;\n  background-color: #ffffff;\n  width: 100%;\n  height: 140px;\n  position: fixed;\n  z-index: 1003; }\n\n.iconContainer {\n  margin-top: 32px;\n  display: block; }\n\n.label-icon label svg,\n.labelIconBox svg {\n  margin-left: 0px !important;\n  fill: #ffffff !important; }\n\n.labelIconBox div label {\n  text-align: inherit !important; }\n\n.overlayBody {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 2; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/UploadDrawer/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/UploadDrawer/index.css
// module chunks = 504